import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import { RadioWrapper } from './radio'

type DirectionType = 'column' | 'row'
export interface RadioGroupProps {
  children?: React.ReactNode[]
  direction?: DirectionType
  useGrid?: boolean
}

const GridStyle = css`
  column-count: 3;
  column-fill: balance;

  ${({ theme }) => theme.mediaQuery.screenS} {
    column-count: 2;
  }

  ${({ theme }) => theme.mediaQuery.phone} {
    column-count: 1;
  }

  > ${RadioWrapper} {
    break-inside: avoid;
    margin-top: 0;
    margin-bottom: ${({ theme }) => theme.space.s16};
  }
`

const BaseStyle = css<{ $direction: DirectionType }>`
  display: flex;
  flex-direction: ${({ $direction }) => $direction};
  flex-wrap: wrap;
`

const StyledRadioGroup = styled.div<{
  $direction: DirectionType
  $useGrid: boolean
}>`
  ${({ $useGrid }) => ($useGrid ? GridStyle : BaseStyle)};
  > ${RadioWrapper} {
    padding: ${({ theme, $direction }) =>
      $direction === 'row'
        ? `0 ${theme.space.s12} 0 0`
        : `${theme.space.s4} 0`};
  }
`

export const useSelected = () => {
  const [selected, setSelected] = useState<string | undefined>(undefined)

  const handleSelection = (value: string | undefined) => {
    if (selected !== value) {
      setSelected(value)
    }
  }

  return { selected, handleSelection }
}

export const RadioGroup = ({
  direction = 'column',
  useGrid = false,
  children,
  ...props
}: RadioGroupProps) => (
  <StyledRadioGroup {...props} $direction={direction} $useGrid={useGrid}>
    {children}
  </StyledRadioGroup>
)
